import React from 'react';
interface IconProps {
  size?: number;
  strokeWidth?: number;
  className?: string;
}
// Minimal premium dive-mask icon (lucide-style: stroke, currentColor, round caps)
export function DiveMaskIcon({
  size = 24,
  strokeWidth = 1.5,
  className
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" data-id="element-112">
      <path d="M4 8.5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a3 3 0 0 1-3 3h-1.6a2 2 0 0 1-1.7-1l-.9-1.5a1.3 1.3 0 0 0-2.2 0l-.9 1.5a2 2 0 0 1-1.7 1H7a3 3 0 0 1-3-3z" data-id="element-113" />
      <path d="M4 9.5 2.5 9M20 9.5 21.5 9" data-id="element-114" />
      <path d="M9.5 17.5a3.5 3.5 0 0 0 5 0" data-id="element-115" />
    </svg>;
}